import type { Image as ImageType } from 'types/capi/shared';

import Image from '~/components/Image';

type Props = {
  image: ImageType;
  isFullWidth?: boolean;
};

const ContentImage = ({ image, isFullWidth = false }: Props) => {
  const isSquare = image.ratio === '1:1';

  return (
    <Image
      alt={image.alt}
      caption={image.caption}
      loading="lazy"
      src={image.url}
      display={isFullWidth ? 'full-bleed' : image.display}
      responsiveOptions={{
        lg: { height: isSquare ? 1160 : 672, width: 1160 },
        md: { height: isSquare ? 1024 : 450, width: 1024 },
        sm: { height: isSquare ? 800 : 450, width: 800 },
        xs: { height: isSquare ? 672 : 300, width: 672 }
      }}
    />
  );
};

export default ContentImage;
